import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: '[datatableResizableHeader]',
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[style.width]': 'width()'
  }
})
export class DatatableResizableHeaderDirective {
  readonly cellId = input.required<string>({
    alias: 'datatableResizableHeader'
  });

  readonly width = computed(
    () => `calc(var(--header-${this.cellId()}-size) * 1px)`
  );
}
